<script>
    import {loadItem} from '@/services/Storage';
    import ButtonNormal from '../buttons/ButtonNormal.vue';

    export default {
        name: 'AppDownload',
        components: {
            ButtonNormal,
        },
        props: {
            header: {
                type: String,
                default: '',
            },
        },
        data() {
            return {
                serverUrl: loadItem('serverUrl'),
                loginId: loadItem('loginId'),
            };
        },
    };
</script>

<template>
    <div class="wrapper">
        <div class="left">
            <div class="description">
                <h2 v-if="header" class="title">{{ header }}</h2>
                Zum Telefonieren benötigst Du noch die App.
                Sobald Du Dir diese installiert hat, bist Du bereit zum
                Telefonieren.
            </div>
            <div class="link">
                <img class="link-icon" src="@/assets/starface_icons_png/24/orange/videotelephone.png" alt="Video icon">
                <a href="https://vimeo.com/380770870" target="_blank">Erste Schritte</a>
            </div>
            <div class="corner-block corner-block-1">
                <div class="title">Apps herunterladen</div>
                <a href="https://starface-up.com/apps" target="_blank">
                    <ButtonNormal buttonTitle="Zum Download" cssClass="btn btn-secondary"/>
                </a>
            </div>
        </div>
        <div class="right">
            <div class="corner-block corner-block-2">
                <div class="title">Daten eingeben</div>
                <p>Die Serverdaten in Deiner App lauten:</p>
                <ul class="credentials">
                    <li><span class="credentials-name">Server:</span><b>{{ serverUrl.replace('.starface-cloud.com', '')
                        }}</b>.starface-cloud.com
                    </li>
                    <li><span class="credentials-name">Login ID:</span><b>{{ loginId }}</b></li>
                    <li>
                       <span class="credentials-name">Passwort:</span>
                       <span>Das Passwort, das wir Dir bereits</span> <br>
                       <span class="password-description-seconnd-part">per Mail zugesendet haben.</span>
                    </li>
                </ul>
            </div>
            <div class="corner-block corner-block-3">
                <div class="title">Telefonie aktivieren</div>
                <p>In der Smartphone-App Telefonie<br/>aktivieren</p>
                <img class="logo" src="@/assets/starfaceMarketing.png" alt="Bild">
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    @import '../../assets/scss/variables.scss';
    @import '../../assets/scss/grid.scss';

    .wrapper {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        max-width: 880px;

        .left, .right {
            flex: 1 auto;
            flex-basis: 50%;
        }

        .left {
            display: flex;
            flex-flow: column;
            .link {
                margin-bottom: 35px;
                .link-icon {
                    padding-right: 16px;
                }

                a {
                    color: $orange;
                    text-decoration: underline;
                    font-size: 18px;
                    letter-spacing: 0;
                    line-height: 24px;
                }
            }
        }

        .corner-block, .description {
            max-width: 385px;
            min-width: 320px;
            margin-bottom: 24px;
            position: relative;
        }

        .description {
            .title {
                margin-bottom: 20px;
            }
        }

        .corner-block {
            font-size: 16px;
            margin-bottom: 40px;

            .title {
                font-size: 18px;
                font-weight: bold;
                margin: 0px 0px 40px 60px;
            }

            a {
                color: $grey-dark;
                display: inline-block;
                height: 25px;
                width: 40%;
                margin-bottom: 20px;

                .text {
                    padding-left: 16px;
                    font-size: 18px;
                }

                img {
                    float: left;
                }
            }

            .credentials {
                margin-top: -10px;
                padding: 0;
                list-style-type: none;
            }

            .credentials-name {
                width: 90px;
                display: inline-block;
            }

            &.corner-block-2 {
                margin-bottom: 40px;
            }
        }

        .corner-block:before {
            position: absolute;
            left: 0;
            top: 0;
            width: 48px;
            height: 48px;
            color: #fff;
            border-bottom-right-radius: 100%;
            background-color: $orange;
            content: '';
            line-height: 37px;
            font-size: 14px;
            text-align: center;

        }

        @for $i from 1 through 3 {
            .corner-block-#{$i}:before {
                content: '#{$i}.';
            }
        }
    }

    .logo {
        max-width: 300px;
        width: 100%;
    }
    .password-description-seconnd-part {
        padding-left: 90px;
    }

    @media screen
    and (min-device-width: 1200px) {
        .wrapper {
            width: 850px;
        }
    }

</style>
